(function () {
  function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }

  var cartFetch = null;
  var lastTotal = 0;
  var lastTs = 0;

  function getCartTotal() {
    var now = Date.now();
    if (now - lastTs < 200) return Promise.resolve(lastTotal);

    if (!cartFetch) {
      cartFetch = fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          var t = (cart && typeof cart.total_price === "number") ? cart.total_price : 0;
          lastTotal = t;
          lastTs = Date.now();
          return t;
        })
        .catch(function () {
          lastTs = Date.now();
          return lastTotal || 0;
        })
        .finally(function () { cartFetch = null; });
    }
    return cartFetch;
  }

  function moneyUSD(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === "function") {
        var fmt = (window.theme && theme.moneyFormat) || (Shopify.money_format || "${{amount}}");
        return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    return (cents / 100).toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  // MESSAGE (UPDATED): wraps {AMOUNT} in span so price can be a different color
  function setMessage(root, total, shipTh, ornTh) {
    var el = root.querySelector("[data-rt-msg]");
    if (!el) return;

    var tShip = root.getAttribute("data-msg-ship") || "ONLY {AMOUNT} FROM FREE SHIPPING";
    var tOrn  = root.getAttribute("data-msg-orn")  || "ONLY {AMOUNT} FROM FREE ORNAMENT";
    var tBoth = root.getAttribute("data-msg-both") || "FREE SHIPPING + ORNAMENT UNLOCKED";

    var shipLeft = Math.max(0, shipTh - total);
    var ornLeft  = Math.max(0, ornTh - total);

    function wrapPrice(amountText) {
      return '<span class="rt-perkbar__price">' + escapeHTML(amountText) + "</span>";
    }

    if (total >= ornTh) {
      el.textContent = tBoth;
      return;
    }

    if (total >= shipTh) {
      el.innerHTML = escapeHTML(tOrn).replace("{AMOUNT}", wrapPrice(moneyUSD(ornLeft)));
      return;
    }

    el.innerHTML = escapeHTML(tShip).replace("{AMOUNT}", wrapPrice(moneyUSD(shipLeft)));
  }

  // Background motion (UNCHANGED)
  function computeBgX(total, bgStartAt, shipTh, ornTh, maskW, bgW, shipWorldPx) {
    var overflow = Math.max(0, bgW - maskW);
    var x0 = 0;
    var xEnd = -overflow;

    var x75 = clamp(-(shipWorldPx - maskW / 2), -overflow, 0);

    if (total <= bgStartAt) return x0;

    if (total < shipTh) {
      var denom1 = Math.max(1, shipTh - bgStartAt);
      var t1 = clamp((total - bgStartAt) / denom1, 0, 1);
      return x0 + (x75 - x0) * t1;
    }

    if (total < ornTh) {
      var denom2 = Math.max(1, ornTh - shipTh);
      var t2 = clamp((total - shipTh) / denom2, 0, 1);
      return x75 + (xEnd - x75) * t2;
    }

    return xEnd;
  }

  // Signs (UNCHANGED)
  function setSigns(root, total, sign75ShowAt, shipTh, ornTh, approach, maskW, bgW) {
    var s75 = root.querySelector('[data-rt-sign="ship"]');
    var s100 = root.querySelector('[data-rt-sign="orn"]');
    if (!s75 || !s100) return;

    var signHalf = 23;

    root.style.setProperty("--rt-hide-x", (maskW + 220) + "px");

    // 75 sign (unchanged)
    var cxStart = maskW * 0.75;
    var cxEnd = signHalf;
    var cx;

    if (total < sign75ShowAt) cx = cxStart;
    else if (total >= shipTh) cx = cxEnd;
    else {
      var denom = Math.max(1, shipTh - sign75ShowAt);
      var t = clamp((total - sign75ShowAt) / denom, 0, 1);
      cx = cxStart + (cxEnd - cxStart) * t;
    }
    root.style.setProperty("--rt-75-cx", Math.round(cx) + "px");

    var show75 = total >= sign75ShowAt;
    var shipNear = total >= (shipTh - approach) && total < shipTh;
    var shipUnlocked = total >= shipTh;

    s75.classList.toggle("is-hidden", !show75);
    s75.classList.toggle("is-near", show75 && shipNear);
    s75.classList.toggle("is-unlocked", show75 && shipUnlocked);

    // 100 sign (unchanged)
    var show100 = total >= shipTh;
    s100.classList.toggle("is-hidden", !show100);

    var unlocked100 = total >= ornTh;
    s100.classList.remove("is-near");
    s100.classList.toggle("is-unlocked", unlocked100);

    var worldBase = bgW * 0.20;
    s100.style.left = Math.round(worldBase) + "px";

    var flushRightCenter = maskW - signHalf;
    var center50 = Math.round(maskW * 0.5);

    var desiredCenter = flushRightCenter;
    if (show100) {
      if (total < 8000) {
        desiredCenter = flushRightCenter;
      } else if (total < ornTh) {
        var t3 = clamp((total - 8000) / Math.max(1, ornTh - 8000), 0, 1);
        desiredCenter = flushRightCenter + (center50 - flushRightCenter) * t3;
      } else {
        desiredCenter = center50;
      }
      desiredCenter = Math.max(desiredCenter, center50);
    }

    var trackX = parseInt(root.style.getPropertyValue("--rt-track-x") || "0", 10);
    var currentWorldCenter = worldBase + trackX;
    var extraX = Math.round(desiredCenter - currentWorldCenter);

    root.style.setProperty("--rt-100-x", extraX + "px");
  }

  function renderOne(root, total) {
    var shipTh = parseInt(root.getAttribute("data-ship-th") || "7500", 10);
    var ornTh  = parseInt(root.getAttribute("data-orn-th")  || "10000", 10);
    var shipPct = parseFloat(root.getAttribute("data-ship-pos") || "86");
    var approach = parseInt(root.getAttribute("data-approach") || "1500", 10);

    var bgStartAt = 2000;
    var sign75ShowAt = 5000;

    var mask = root.querySelector("[data-rt-mask]");
    var track = root.querySelector("[data-rt-track]");
    var bg = root.querySelector("[data-rt-bg]");
    if (!mask || !track || !bg) return;

    function doLayout() {
      var bgW = bg.naturalWidth || 1100;
      var bgH = bg.naturalHeight || 100;

      root.style.setProperty("--rt-bg-w", bgW + "px");
      root.style.setProperty("--rt-bg-h", bgH + "px");

      var maskW = mask.getBoundingClientRect().width;

      root.classList.toggle("rt-perkbar--orn-unlocked", total >= ornTh);

      setMessage(root, total, shipTh, ornTh);

      // Waypoint guard (UNCHANGED)
      var overflow = Math.max(0, bgW - maskW);
      var maxShipWorld = overflow + (maskW / 2) - 12;
      var shipWorldPx = bgW * (shipPct / 100);
      if (shipWorldPx > maxShipWorld) shipWorldPx = maxShipWorld;

      var x = computeBgX(total, bgStartAt, shipTh, ornTh, maskW, bgW, shipWorldPx);
      var xr = Math.round(x);

      root.style.setProperty("--rt-track-x", xr + "px");
      track.style.transform = "translateX(" + xr + "px)";

      setSigns(root, total, sign75ShowAt, shipTh, ornTh, approach, maskW, bgW);
    }

    if (bg.complete) doLayout();
    else bg.addEventListener("load", doLayout, { once: true });
  }

  var refreshTimer = null;
  var inRefresh = false;

  function scheduleRefresh(delay) {
    var d = (typeof delay === "number") ? delay : 120;
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      refreshAll();
    }, d);
  }

  function refreshAll() {
    if (inRefresh) return;
    inRefresh = true;

    var roots = document.querySelectorAll("[data-rt-perkbar]");
    if (!roots.length) { inRefresh = false; return; }

    getCartTotal()
      .then(function (total) {
        for (var i = 0; i < roots.length; i++) renderOne(roots[i], total);
      })
      .catch(function () {})
      .finally(function () { inRefresh = false; });
  }

  function isCartMutatingUrl(url) {
    if (!url) return false;
    var u = String(url);
    return (
      u.indexOf("/cart/add") !== -1 ||
      u.indexOf("/cart/change") !== -1 ||
      u.indexOf("/cart/update") !== -1 ||
      u.indexOf("/cart/clear") !== -1
    );
  }

  function hookFetchCartChanges() {
    if (!window.fetch || window.__rtPerkbarFetchWrapped) return;
    window.__rtPerkbarFetchWrapped = true;

    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments && arguments[0];
      var watch = isCartMutatingUrl(url);
      var p = origFetch.apply(this, arguments);

      if (watch) {
        scheduleRefresh(160);
        Promise.resolve(p)
          .then(function () {
            lastTs = 0;
            scheduleRefresh(60);
            setTimeout(function () { lastTs = 0; scheduleRefresh(0); }, 650);
          })
          .catch(function () {
            lastTs = 0;
            scheduleRefresh(350);
          });
      }
      return p;
    };
  }

  function hookClicks() {
    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (
        t.closest("#t4s-mini_cart") ||
        t.closest(".t4s-mini_cart") ||
        t.closest("[data-cart-wrapper]")
      ) {
        scheduleRefresh(220);
        setTimeout(function () { lastTs = 0; scheduleRefresh(0); }, 900);
      }
    }, true);
  }

  function hookMutations() {
    var obs = new MutationObserver(function () { scheduleRefresh(80); });
    obs.observe(document.body, { subtree: true, childList: true });
  }

  function hookResize() {
    if (!("ResizeObserver" in window)) {
      window.addEventListener("resize", function () { scheduleRefresh(120); }, { passive: true });
      return;
    }
    var ro = new ResizeObserver(function () { scheduleRefresh(80); });
    var els = document.querySelectorAll("[data-rt-perkbar] [data-rt-mask]");
    for (var i = 0; i < els.length; i++) ro.observe(els[i]);
  }

  function hook() {
    hookFetchCartChanges();
    hookClicks();
    hookMutations();
    hookResize();
    scheduleRefresh(0);
  }

  document.addEventListener("DOMContentLoaded", hook);

  window.RTPerkbarRefresh = function () {
    lastTs = 0;
    scheduleRefresh(0);
  };
})();
